import React from 'react';
import { defineMessages } from 'react-intl';

import Message from 'components/Message';
import Confirm from 'components/Confirm';

import './StaffAccountModal.scss';

const messages = defineMessages({
  title: {
    id: 'staff-account.delete-staff-account-confirmation-modal.title',
    defaultMessage: 'Delete user',
  },
  description: {
    id: 'staff-account.delete-staff-account-confirmation-modal.description',
    defaultMessage: 'Are you sure you want to delete this user from your staff?',
  },
  cancel: {
    id: 'staff-account.delete-staff-account-confirmation-modal.cancel',
    defaultMessage: 'Cancel',
  },
  submit: {
    id: 'staff-account.delete-staff-account-confirmation-modal.submit',
    defaultMessage: 'Submit',
  },
});

const DeleteStaffAccountConfirmationModal = props => (
  <Confirm
    cancelNode={<Message message={messages.cancel} />}
    acceptNode={<Message message={messages.submit} />}
    title={<Message message={messages.title} />}
    {...props}>
    <Message message={messages.description} />
  </Confirm>
);

export default DeleteStaffAccountConfirmationModal;
